import Sentry from '../instrument';
import { toast, ToastOptions, ToastContent } from 'react-toastify';

const originalError = toast.error;

toast.error = function <TData = unknown>(
  content: ToastContent<TData>,
  options?: ToastOptions
) {
  const isValidContent = typeof content === 'string';
  const isHelpfulError = content !== 'Something went wrong';

  if (isValidContent && isHelpfulError) {
    Sentry.captureMessage(content.replace(/\n/g, ' '), 'error');
  }
  return originalError(content, options);
};

export default toast;
